import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import ProductCarousel from "../../components/general/products/productCarousel/productCarousel";
import Hero from "../../components/home/hero";
import { PAGE_HOME } from "../../locales/pages/namespaces";
import { api } from "../products/mock/mockApi";
import Images from "../../assets";
import Paper from "@mui/material/Paper";
import Tile from "../../components/home/tiles";
import DiscountTile from "../../components/home/discountTile";


const TOKENS = {
    contentMax: 1335,
    topHeight: 544,
    radiusLg: 4,
    gapPx: 30,
    gray: "#9E9E9E",
    panelTopBg: '#F0F0F0',
    panelBg: '#FFFFFF',
    stroke: '#E9E9E9',
};
const CONTAINER_W = {
    width: '95vw',
    //maxWidth: 1720,
    mx: 'auto',
};

function Panel({children, sx = {}, className, noPadding = false}) {
    return (
        <Paper
            elevation={0}
            className={className}
            sx={{
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                boxSizing: 'border-box',
                overflow: 'hidden',
                bgcolor: TOKENS.stroke,
                borderColor: TOKENS.panelTopBg,
                borderRadius: TOKENS.radiusLg,
                p: noPadding ? 0 : { xs: 2, md: 3 },
                '& img': { maxWidth: '100%', height: 'auto' },
                ...sx,
            }}
        >
            {children}
        </Paper>
    );
}

const Home = (props) => {
  const { t } = useTranslation(PAGE_HOME);
  const history = useHistory();

  // --- only change: load products from api ---
  const [product, setProduct] = useState({ recommendations: [] });

  useEffect(() => {
    let alive = true;
    const controller = new AbortController();

    api
      .fetchProducts({ page: 1, limit: 12 }, { signal: controller.signal })
      .then((data) => {
        if (!alive) return;
        // keep shape compatible with existing usages (product.recommendations)
        setProduct((prev) => ({ ...prev, recommendations: data.items || [] }));
      })
      .catch(() => {
        if (!alive) return;
        setProduct((prev) => ({ ...prev, recommendations: [] }));
      });

    return () => {
      alive = false;
      controller.abort();
    };
  }, []);
  // --- end change ---

  const title = t("THIS IS A BIG TITLE FOR BREW PRODUCTS");
  const header = t("");
  return (
    <Box
        sx={{
            width: "95%",
            //maxWidth: 1760,
            mx: "auto",
    }}
    >
                <Box sx={{mb:2}}>
                    <Hero title={title} header={header} />
                </Box>

        <Box
            sx={{
                mt: 2,
                display: "grid",
                gap: "10px",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "559fr 402fr 359fr",
                },
                alignItems: "stretch",
            }}
        >
            {/* Left: 559 x 520 */}
            <Tile
                title={t("SCALES")}
                image={Images.weighCof}
                onClick={() =>  history.push({
                    pathname: "/products",
                    state: {
                        categoryId: 26,
                    },
                })}
                aspectRatio="559 / 520"
                sx={{
                    height: { sm: 520 },
                    minHeight: { xs: 180, sm: 520 },
                }}
            />

            {/* Middle: 402 x 520 */}
            <Tile
                title={t("COFFEE")}
                image={Images.coffee22}
                onClick={() =>  history.push({
                    pathname: "/products",
                    state: {
                        categoryId: [39,40,41,42,43,44,45],
                    },
                })}
                aspectRatio="402 / 520"
                sx={{
                    height: { sm: 520 },
                    minHeight: { xs: 180, sm: 520 },
                }}
            />
            <Box
                sx={{
                    display: "grid",
                    gridTemplateRows: { xs: "auto", sm: "255px 255px" },
                    gap: "10px",
                    minWidth: 0,
                    height: { sm: 520 },
                }}
            >
                <Tile
                    variant="square"
                    title={t("FILTERS")}
                    image={Images.filtra}
                    onClick={() =>  history.push({
                        pathname: "/products",
                        state: {
                            categoryId: 24,
                        },
                    })}
                    aspectRatio="359 / 255"
                    sx={{
                        minHeight: { xs: 160, sm: 255 },
                    }}
                />

                <DiscountTile
                    preTitle={t("SPECIAL")}
                    title={t("SPECIAL OFFERS")}
                    description={t("Offers and promos.")}
                    image={Images.discountImage}
                    hoverIcon={Images.discountImage}
                    hoverOverlayColor="#E5007E"
                    onClick={() => history.push("/offers")}
                    aspectRatio="359 / 255"
                    sx={{ minHeight: { xs: 160, sm: 255 } }}
                />
            </Box>
        </Box>



        {/* Product Carousels */}
      {/*<Box*/}
      {/*  sx={{*/}
      {/*    mx: "auto",*/}
      {/*    width: "100%",*/}
      {/*    display: "flex",*/}
      {/*    flexDirection: "column",*/}
      {/*    gap: 2,*/}
      {/*  }}*/}
      {/*>*/}
      {/*    <Box sx={{...CONTAINER_W, mt: 2}}>*/}
      {/*            <Panel sx={{p: {xs: 2, md: 3}}}>*/}
      {/*                <ProductCarousel*/}
      {/*                    title={t("BEST SELLERS")}*/}
      {/*                    products={product.recommendations ?? []}*/}
      {/*                    allProducts={true}*/}
      {/*                    onSeeAll={() => history.push("/products")}*/}
      {/*                />*/}
      {/*            </Panel>*/}
      {/*    </Box>*/}
      {/*    <Box sx={{...CONTAINER_W, mt: 2,mb:2}}>*/}
      {/*            <Panel sx={{p: {xs: 2, md: 3}}}>*/}
      {/*                <ProductCarousel*/}
      {/*                    title={t("NEW PRODUCTS")}*/}
      {/*                    products={product.recommendations ?? []}*/}
      {/*                    allProducts={false}*/}
      {/*                />*/}
      {/*            </Panel>*/}
      {/*    </Box>*/}
      {/*</Box>*/}
      {/*  <Box*/}
      {/*      sx={{*/}
      {/*          mt: 2,*/}
      {/*          display: "grid",*/}
      {/*          gap: "10px",*/}
      {/*          gridTemplateColumns: {*/}
      {/*              xs: "1fr",*/}
      {/*              sm: "4fr 4fr",*/}
      {/*          },*/}
      {/*          alignItems: "stretch",*/}
      {/*      }}*/}
      {/*  >*/}
      {/*      <Tile*/}
      {/*          preTitle={t("ABOUT US")}*/}
      {/*          title={t("THIS IS A BIG TITLE BANNER IN TWO LINES")}*/}
      {/*          description="Tortor vel facilisis condimentum donec lacus sed ac..."*/}
      {/*          image={Images.coffeeNew}*/}
      {/*          onClick={() => history.push("/products")}*/}
      {/*          aspectRatio={{ xs: "16 / 10", sm: "900 / 500" }}*/}
      {/*          sx={{ minHeight: { xs: 220, sm: 500 } }}*/}
      {/*      />*/}

      {/*      <Box*/}
      {/*          sx={{*/}
      {/*              display: "grid",*/}
      {/*              gridTemplateRows: { xs: "auto", sm: "245px 245px" },*/}
      {/*              gap: "10px",*/}
      {/*              height: { sm: 500 },*/}
      {/*              minWidth: 0,*/}
      {/*          }}*/}
      {/*      >*/}
      {/*          <Tile*/}
      {/*              preTitle={t("ABOUT US")}*/}
      {/*              title={t("SERVICE TITLE")}*/}
      {/*              description="Tortor vel facilisis..."*/}
      {/*              image={Images.coffeeNew}*/}
      {/*              onClick={() => history.push("/products")}*/}
      {/*              aspectRatio="950 / 245"*/}
      {/*              sx={{ minHeight: { xs: 200, sm: 245 } }}*/}
      {/*          />*/}

      {/*          <Tile*/}
      {/*              preTitle={t("ABOUT US")}*/}
      {/*              title={t("SERVICE TITLE")}*/}
      {/*              description="Tortor vel facilisis..."*/}
      {/*              image={Images.coffeeNew}*/}
      {/*              onClick={() => history.push("/offers")}*/}
      {/*              aspectRatio="950 / 245"*/}
      {/*              sx={{ minHeight: { xs: 200, sm: 245 } }}*/}
      {/*          />*/}
      {/*      </Box>*/}
      {/*  </Box>*/}

    </Box>
  );
};

export default Home;



